import {Component, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExgModalService, ExgPopupComponent} from 'exc-controls-v2';
import {ExcSecurityService} from 'exc-security-v2';

@Component({
  selector: 'app-questionnaire-renderer',
  templateUrl: './questionnaire-renderer.component.html',
  styles: []
})
export class QuestionnaireRendererComponent extends ExcTranslation implements OnInit {
  @ViewChild('questionnaire') questionnaireForm: any | undefined;
  @ViewChild('popUp', {read: ExgPopupComponent}) popUp: ExgPopupComponent | undefined;
  @ViewChild('image', {read: ExgPopupComponent}) imageContainer: ExgPopupComponent | undefined;
  excRestServiceCore = ExcCoreModule.Services().ExcRest;
  tabinstance: any;
  metaInfo: any = {dataFilter: {}, dataPaging: {}, dataSort: {}};
  Data: any = {
    Questions: [],
    Chapters: [],
    Questionnaire: [],
    QuestionnaireStatistics: [],
    Task: {},
    Conditions: [],
    qverID: '89EF8A58-D209-4702-8147-7627FBF5D65C',
    qcfgName: 'Test'
  };
  questionnaireList: any[] = [];
  selectedChapter: any;
  tableState = 0;
  state: number | undefined;
  drawer = false;
  selectedHelpText: any;

  isLoading = true;

  fake: any[] = [];
  fakeCurrent = 5;
  selectedConditionQuestions = '';
  isSkippedList: any[] = [];
  selectedQuest: any;

  ComponentUID = ExcCoreModule.Guid.NewGuid();

  constructor(private modalService: ExgModalService, public excSecurity: ExcSecurityService) {
    super();
  }

  ngOnInit(): void {
    const _self = this;
    this.state = 11; // _self.Data.tsk_enmIdent_Taskstate;
    _self.getChapterData();
  }

  /** Data Calls */
  getChapterData(noQuestionLoad = false): void {
    const _self = this;
    _self.tableState = 1;
    _self.Data.Chapters = [];
    const url = _self.excRestServiceCore.computeUrl('QuestionnaireR_List_Chapters', {
      qcnfID: _self.Data.qcnfID,
      qverID: _self.Data.qverID
    });
    _self.excRestServiceCore.sget(url, ExcCoreModule.Guid.NewGuid(), {MetaInfo: _self.metaInfo})
      .subscribe((ret: any) => {
        if (ret.success && ret.data) {
          _self.Data.Chapters = ret.data.QuestionnaireChapters;
          _self.Data.Conditions = ret.data.Conditions;
          if (_self.selectedChapter === undefined) {
            _self.selectedChapter = _self.Data.Chapters[0];
          }
          _self.tableState = 0;
          if (!noQuestionLoad) {
            _self.getQuestionnaireData();
          }
        } else {
          _self.tableState = 2;
        }
      });
  }

  getQuestionnaireData(): void {
    const _self = this;
    this.isLoading = true;
    _self.questionnaireList = [];
    const splitted = _self.selectedChapter.questKey.split('.', 10);
    const result = splitted.join('');
    const url = _self.excRestServiceCore.computeUrl('QuestionnaireResultR_List', {
      qcnfID: _self.selectedChapter.quest_qcnfID,
      questID: _self.selectedChapter.questID,
      qverID: _self.Data.qverID
    });
    _self.excRestServiceCore.sget(url, ExcCoreModule.Guid.NewGuid(), {})
      .subscribe((ret: any) => {
        if (ret.success && ret.data) {
          if (ret.data.QuestionnaireQuestions.length > 0 && ret.data.QuestionnaireQuestions !== 'undefined') {
            _self.questionnaireList = ret.data.QuestionnaireQuestions as any[];
            _self.Data.QuestionnaireStatistics = ret.data.QuestionnaireStatistics;
            _self.Data.Conditions = ret.data.Conditions;
            _self.questionnaireList.forEach((element) => {
              element.Answered = element.rstID !== null;
              if (element.cmpValue === null) {
                element.cmpValue = 0;
              }
              if (![1, 2, 3, 4, 5].includes(element.quest_enmIdent_questValueFormat) && element.rstValue === '<SKIP>') {
                this.isSkippedList.push(element.questID);
                element.rstValue = null;
              }
              if (element.quest_enmIdent_questValueFormat === 12) {
                // ngx Mask Transformation for decimal display
                if (element.rstValue && String(element.rstValue).includes('.')) {
                  element.rstValue = element.rstValue.replace('.', ',');
                }
              }
              if (element.questConfiguration?.length > 0 && [17, 19].includes(element.quest_enmIdent_questValueFormat)) {
                element.configs = JSON.parse(element.questConfiguration);
              }
              if (element.quest_enmIdent_questType === 19 && element.rstValue) {
                element.rstValue = JSON.parse(element.rstValue);
              }
            });
            this.fake = new Array(this.Data.QuestionnaireStatistics.QuestionsCount || 0);
            this.fakeCurrent = this.Data.QuestionnaireStatistics.ResultCount || 0;
          }
        }
        this.isLoading = false;
      });
  }

  /** Save Questionnaire Functions */
  saveQuestionnaireAnswer(object: any): void {
    const _self = this;
    if (this.checkFormValidation(object)) {
      return;
    }
    ExcCoreModule.call('QuestionnaireActivator');
    if (object.Answered === true) {
      _self.excRestServiceCore.sput(_self.excRestServiceCore.computeUrl('QuestionnaireResultU', {}), {
        rstValue: object.rstValue,
        rstID: object.rstID,
        segtskID: _self.Data.qverID
      }, ExcCoreModule.Guid.NewGuid(), {}).subscribe((ret: any)  => {
        this.assignResponseData(ret);
        if (ret.data.Deleted.NotDeleted === 0) {
          object.Answered = false;
        }
      });
    } else if ((object.Answered === false && object.rstValue !== null && object.rstValue !== undefined)
      || (object.Answered === true && object.rstValue !== '')) {
      _self.excRestServiceCore.spost(_self.excRestServiceCore.computeUrl('QuestionnaireResultC', {}), {
        rst_questID: object.questID,
        rst_qverID: _self.Data.qverID,
        rst_qcnfID: object.quest_qcnfID,
        rst_enmIdent_questValueFormat: object.quest_enmIdent_questValueFormat,
        rstValue: object.rstValue,
        rstLON: null,
        rstLAT: null,
        rst_kidID: null,
        rstIsTest: true
      }, ExcCoreModule.Guid.NewGuid(), {}).subscribe((ret: any) => {
        if (object.quest_enmIdent_questValueFormat === 3 && object.rstValue !== '<SKIP>') {
          object.questID = object.rstValue;
        }
        object.Answered = true;
        object.rstID = ret.data.NewObject.rstID;
        this.assignResponseData(ret);
      });
    }
  }

  checkFormValidation(object: any): boolean {
    let isInvalid = false;
    if (object.questID in this.questionnaireForm.controls) {
      Object.keys(this.questionnaireForm.controls).forEach(key => {
        if (key === object.questID) {
          isInvalid = this.questionnaireForm.controls[key].status === 'INVALID';
        }
      });
    }
    return isInvalid;
  }

  assignResponseData(response: any): void {
    this.Data.QuestionnaireStatistics = response.data.QuestionnaireStatistics;
    this.Data.Chapters = response.data.Chapters;
    this.changeConditionalQuestions(response.data.Conditions);
    this.fake = new Array(this.Data.QuestionnaireStatistics.QuestionsCount || 0);
    this.fakeCurrent = this.Data.QuestionnaireStatistics.ResultCount || 0;
  }

  changeConditionalQuestions(responseList: any): void {
    const _self = this;
    if (responseList.length > 0) {
      _self.questionnaireList.forEach((question) => {
        responseList.forEach((conditional: any) => {
          if (conditional.questID === question.questID) {
            question.ConditionMet = conditional.ConditionMet;
            if (conditional.ConditionMet === 0) {
              question.rstValue = null;
              question.cmpValue = null;
            }
          }
        });
      });
    }
  }

  deleteAnswer(object: any, reload = true): void {
    const _self = this;
    ExcCoreModule.call('QuestionnaireActivator');
    _self.excRestServiceCore.delete(_self.excRestServiceCore.computeUrl('QuestionnaireResultD', {}), {
      rstID: object.rstID,
      segtskID: _self.Data.qverID
    }, {}, false).subscribe((response: any) => {
      if (reload) {
        this.Data.Chapters = response?.data?.Chapters;
      }
      object.Answered = false;
      this.questionnaireList.forEach(element => {
          if (element.questConditional && element.questCondition === object.questID) {
            element.ConditionMet = null;
          }
        }
      );
      _self.getStatistics();
      if (!reload) {
        object.Answered = false;
        object.rstValue = '<SKIP>';
        _self.saveQuestionnaireAnswer(object);
        object.rstValue = null;
      }
    });
  }

  /** Generic Questionnaire Functions */
  togglePopupMenu(e: any, context: any): void {
    this.selectedConditionQuestions = context;
    this.popUp?.openUnderLeft(e);
  }

  toggleDrawer(text: any): void {
    if (text === undefined) {
    } else {
      this.selectedHelpText = text;
      this.drawer = this.drawer === false;
    }
  }

  closeDrawer(): void {
    const _self = this;
    _self.drawer = false;
  }

  toggleZoom(e: any, item: any): void {
    this.selectedQuest = item;
    this.imageContainer?.openAboveCenter(e);
  }

  /** Questionnaire Answer Functions */
  setRatingInputValue(object: any, value: any): void {
    if (object.rstValue !== value) {
      object.rstValue = value;
      this.saveQuestionnaireAnswer(object);
    }
  }

  radioInput(event: any, item: any): void {
    const _self = this;
    if (this.isValidToEdit()) {
      const parent = this.getParent(item);
      const elementConditions = this.questionnaireList.filter(conditional =>
        conditional.questCondition === parent.rstValue && conditional.ConditionMet === 1 && conditional.rstValue !== null);
      if (elementConditions.length > 0) {
        this.modalService.showSimple(this.getRessource('ConditionalChangeHeader'), this.getRessource('ConditionalChangeText')
          , true, true, this.getGlobal('Continue'), this.getGlobal('Cancel')).subscribe(args => {
          if (args) {
            for (const element of elementConditions) {
              element.Answered = false;
            }
            this.saveRadioParentResult(item);
          }
        });
        event.preventDefault();
        event.stopPropagation();
      } else {
        this.saveRadioParentResult(item);
      }
    }
  }

  saveRadioParentResult(item: any): void {
    const _self = this;
    _self.questionnaireList.forEach((element) => {
      if (element.questKey === item.questParentkey) {
        if (element.rstValue !== item.questID) {
          element.rstValue = item.questID;
          _self.saveQuestionnaireAnswer(element);
        }
      }
    });
  }

  checkBoxInput(event: any, object: any): void {
    const _self = this;
    if (!object.Answered) {
      object.rstValue = object.questID;
      _self.questionnaireList.forEach((element) => {
        if (element.questKey === object.questParentkey) {
          object.questID = element.questID;
        }
        if (element.questCondition === object.questID) {
          element.ConditionMet = 1;
        }
      });
      _self.saveQuestionnaireAnswer(object);
    } else {
      event.preventDefault();
      event.stopPropagation();
      const elementConditions = this.questionnaireList.filter(conditional =>
        conditional.questCondition === object.questID && conditional.ConditionMet === 1 && conditional.rstValue !== null);
      if (elementConditions.length > 0) {
        this.modalService.showSimple(this.getRessource('ConditionalChangeHeader'), this.getRessource('ConditionalChangeText')
          , true, true, this.getGlobal('Continue'), this.getGlobal('Cancel')).subscribe(args => {
          if (args) {
            for (const element of elementConditions) {
              element.Answered = false;
            }
            _self.deleteAnswer(object);
          }
        });
      } else {
        _self.deleteAnswer(object);
      }
    }
  }

  onTagInputEnter(event: any, item: any): void {
    const stringValue = event.target.value;
    if (stringValue && stringValue !== '') {
      let arr: string[] = [];
      if (item.rstValue) {
        arr = JSON.parse(item.rstValue);
      }
      if (stringValue.includes(',', ';')) {
        const csv = stringValue.split(',');
        for (const value of csv) {
          if (!arr.includes(value)) {
            arr.push(value);
          }
        }
        item.rstValue = JSON.stringify(arr);
        this.saveQuestionnaireAnswer(item);
      } else if (!arr.includes(stringValue)) {
        arr.push(stringValue);
        item.rstValue = JSON.stringify(arr);
        this.saveQuestionnaireAnswer(item);
      }
      event.target.value = '';
    }
  }

  removeTagInputChip(chip: any, item: any): void {
    if (!this.isDisabled(item) && !this.isSkipped(item)) {
      let arr: string[] = JSON.parse(item.rstValue);
      arr = arr.filter(x => x !== chip);
      item.rstValue = JSON.stringify(arr);
      if (arr && arr.length > 0) {
        this.saveQuestionnaireAnswer(item);
      } else {
        this.deleteAnswer(item);
      }
    }
  }

  changeMatrixCheck(item: any, rowIndex: number, colIndex: number): void {
    let rstValue: any[];
    if (item.rstValue) {
      rstValue = JSON.parse(item.rstValue);
    } else {
      rstValue = JSON.parse(JSON.stringify(item.configs));
      rstValue.forEach(x => {
        x.cols.forEach((y: any) => {
          y.score = null;
        });
      });
    }
    const lastScore = rstValue[rowIndex].cols[colIndex].score;
    // Uncheck the previous checked checkbox in the same row
    rstValue.forEach(rows => {
      for (const col of rows.cols) {
        col.score = null;
      }
    });
    // Update the rstValue array
    if (lastScore === item.configs[rowIndex].cols[colIndex].score && lastScore !== null) {
      rstValue[rowIndex].cols[colIndex].score = null;
      item.rstValue = null;
      this.deleteAnswer(item);
      return;
    } else {
      rstValue[rowIndex].cols[colIndex].score = item.configs[rowIndex].cols[colIndex].score;
    }
    item.rstValue = JSON.stringify(rstValue);
    this.isSkippedList = this.isSkippedList.filter(x => x !== item.questID);
    if (this.isDeleteTable(item)) {
      this.deleteAnswer(item);
    } else {
      this.saveQuestionnaireAnswer(item);
    }
  }

  setFormSubmit(resultObject: any, question: any): void {
    question.rstValue = JSON.stringify(resultObject);
    this.saveQuestionnaireAnswer(question);
  }

  getJSONObject(element: any): any {
    return JSON.parse(element);
  }

  /** Upload Functions */
  fileUpload(fileData: any, questData: any): void {
    const _self = this;
    ExcCoreModule.call('QuestionnaireActivator');
    const formData = new FormData();
    fileData.forEach((fileItem: any) => formData.append('file[]', fileItem.asBlob, fileItem.fullName));
    const url = _self.excRestServiceCore.computeUrl('QuestionnaireResultAttachmentC', {
      FKID: questData.questID,
      qverID: _self.Data.qverID
    });
    _self.excRestServiceCore.post(url,
      formData, {})
      .subscribe((response: any) => {
        if (response.data[0]) {
          _self.Data.QuestionnaireStatistics = response.data[0];
          this.getChapterData(true);
        }
        questData.cmpValue = Number(questData.cmpValue) + fileData.length;
      });
  }

  openAttachmentViewer(quest: any): void {
    const _self = this;
    let isDisabled: boolean;
    isDisabled = _self.isDisabled(quest);
    this.modalService.show('ModalAttachmentViewerComponent'
      , {
        ID: quest.questID, qverID: this.Data.qverID, isDisabled, entityName: 'QuestionnaireResultAttachment',
        extensionName: '', index: 0
      }).subscribe(data => {
      quest.cmpValue = data;
      _self.getStatistics();
      this.getChapterData(true);
    });
  }

  /** Questionnaire Skipping Questions */
  checkBoxSkipable(item: any): void {
    const _self = this;
    if ([1, 2].includes(item.quest_enmIdent_questValueFormat)) {
      const parentNode = _self.getParent(item);
      if (_self.isSkipped(_self.getParent(item))) {
        parentNode.rstValue = null;
        _self.saveQuestionnaireAnswer(parentNode);
      } else {
        parentNode.rstValue = '<SKIP>';
        _self.saveQuestionnaireAnswer(parentNode);
      }
    } else if (item.quest_enmIdent_questValueFormat === 3) {
      const parentNode = _self.getParent(item);
      if (_self.isSkipped(_self.getParent(item))) {
        parentNode.rstValue = null;
        this.deleteAnswer(parentNode);
      } else {
        parentNode.rstValue = '<SKIP>';
        this.questionnaireList.forEach((x) => {
          if (x.questParentkey === parentNode.questKey) {
            x.rstValue = null;
            x.Answered = false;
          }
        });
        _self.saveQuestionnaireAnswer(parentNode);
      }
    } else if ([6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19].includes(item.quest_enmIdent_questValueFormat)) {
      if (_self.isSkipped(item)) {
        item.rstValue = null;
        this.isSkippedList = this.isSkippedList.filter(x => x !== item.questID);
        _self.deleteAnswer(item);
      } else {
        this.isSkippedList.push(item.questID);
        if (item.rstID) {
          _self.deleteAnswer(item, false);
        } else {
          item.Answered = false;
          item.rstValue = '<SKIP>';
          _self.saveQuestionnaireAnswer(item);
          item.rstValue = null;
        }
      }
    } else if ([4, 5].includes(item.quest_enmIdent_questValueFormat)) {
      if (_self.isSkipped(item)) {
        item.cmpValue = 0;
        item.rstValue = null;
        _self.deleteAnswer(item);
      } else {
        item.rstValue = '<SKIP>';
        item.cmpValue = 0;
        _self.saveQuestionnaireAnswer(item);
      }
    }
  }

  /** Additional Functions */
  onRowSelect(index: number): void {
    const _self = this;
    _self.selectedChapter = _self.Data.Chapters[index];
    _self.getQuestionnaireData();
  }

  navigateToChapter(item: any): void {
    const parentID = this.Data.Conditions.find((x: any) => x.questID === item.questID)?.ParentID;
    this.onRowSelect(this.Data.Chapters.findIndex((x: any) => x.questID === parentID));
  }

  openTaskFinishModal(): void {
    const _self = this;
    this.Data.tsk_enmIdent_Taskstate = this.Data.QuestionnaireStatistics.TaskStatus;
    this.modalService.show('ModalQbaTaskFinishComponent', {Task: this.Data}).subscribe(data => {
      if (data) {
        const taskObject = data.data;
        let postObject;
        if (data.isEnd && !data.isHandOver) {
          postObject = {
            tskUPT: taskObject.tskUPT
            , tskAuditorComment: taskObject.tskAuditorComment
            , tskAuditorStartDate: taskObject.tskAuditorStartDate
            , tskAuditorEndDate: taskObject.tskAuditorEndDate
            , tskInsightDocuments: taskObject.tskInsightDocuments
            , tskInsightAccounting: taskObject.tskInsightAccounting
            , tskInsightDataIntegrity: taskObject.tskInsightDataIntegrity
            , tskInsightFraud: taskObject.tskInsightFraud
            , tskInsightFindingsCache: taskObject.tskInsightFindingsCache
            , tskFinalResult: taskObject.tskFinalResult
            , tskHandOverDate: taskObject.tskHandOverDate
            , tskReportEmail: taskObject.tskReportEmail
            , tskSignature: taskObject.tskSignature
            , IsSave: false
          };
          const url = _self.excRestServiceCore.computeUrl('FinishAudit', {qverID: taskObject.qverID});
          _self.excRestServiceCore.post(url, postObject, null).subscribe((ret: any) => {
            this.Data = ret.data[0];
            _self.state = this.Data.tsk_enmIdent_Taskstate;
            // _self.getChapterData();
            ExcCoreModule.call('checkviewClosed', true);
            if (_self.tabinstance.Config && _self.tabinstance.Config.ReloadParent) {
              _self.tabinstance.Config.ReloadParent();
            }
            this.tabinstance.Close();
          });
        } else if (!data.isEnd && data.isHandOver) {
          postObject = {
            tskUPT: taskObject.tskUPT
            , tskAuditorComment: taskObject.tskAuditorComment
            , tskInsightDocumentsHandover: this.isUndefined(taskObject.InsightDocumentsHandover)
            , tskInsightAccountingHandover: this.isUndefined(taskObject.InsightAccountingHandover)
            , tskInsightDataIntegrityHandover: this.isUndefined(taskObject.InsightDataIntegrityHandover)
            , tskInsightFraudHandover: this.isUndefined(taskObject.InsightFraudHandover)
            , tskInsightFindingsCacheHandover: this.isUndefined(taskObject.InsightFindingsHandover)
            , tskFinalResult: 0
            , tskReportEmail: taskObject.tskReportEmail
            , IsSave: 0
            , tskHandsOver: 1
            , qverID: taskObject.qverID
          };
          const url = _self.excRestServiceCore.computeUrl('EndHandOver', {qverID: taskObject.qverID});
          _self.excRestServiceCore.post(url, postObject, null).subscribe((ret: any) => {
            // _self.getChapterData();
            this.Data = ret.data[0];
            _self.state = this.Data.tsk_enmIdent_Taskstate;
            ExcCoreModule.call('checkviewClosed', true);
            if (_self.tabinstance.Config && _self.tabinstance.Config.ReloadParent) {
              _self.tabinstance.Config.ReloadParent();
            }
            this.tabinstance.Close();
          });
        }
      }
    });
  }

  /** Return Functions */
  parentValue(object: any): boolean {
    const _self = this;
    let returnValue = false;
    if (object) {
      _self.questionnaireList.forEach((element) => {
        if (element.questKey === object.questParentkey) {
          returnValue = element.rstValue === object.questID;
        }
      });
    } else {
      returnValue = false;
    }
    return returnValue;
  }

  isValidToEdit(): boolean {
    const _self = this;
    return _self.state !== undefined && (_self.state <= 5 || _self.state === 11);
  }

  isConditionalAndNotValid(x: any): boolean {
    return x.questConditional && !x.ConditionMet;
  }

  isParentConditionalAndNotValid(x: any): boolean {
    const _self = this;
    let parent = x;
    _self.questionnaireList.forEach((question) => {
      if (x.questParentkey === question.questKey) {
        parent = question;
      }
    });
    return parent.questConditional && !parent.ConditionMet;
  }

  isNotConditionalOrValid(x: any): boolean {
    return !x.questConditional || (x.questConditional && x.ConditionMet);
  }

  isDisabled(x: any): boolean {
    const _self = this;
    return !_self.isValidToEdit() || _self.isConditionalAndNotValid(x);
  }

  isDisabledParent(x: any): boolean {
    const _self = this;
    return !_self.isValidToEdit() || _self.isParentConditionalAndNotValid(x);
  }

  isSkippedItem(item: any, x: number): boolean {
    return (([1, 2, 3].includes(item.quest_enmIdent_questValueFormat)
      && item.quest_enmIdent_questType === 3 && (this.questionnaireList[x + 1]?.quest_enmIdent_questType === 2 ||
        !this.questionnaireList[x + 1])) && this.getParent(item)?.questIsInapplicable)
      && this.isNotConditionalOrValid(this.getParent(item)) ||
      (item.questIsInapplicable && ![1, 2, 3].includes(item.quest_enmIdent_questValueFormat) && this.isNotConditionalOrValid(item));
  }

  hasConditionalQuestion(item: any): boolean {
    return (this.Data.Conditions && this.Data.Conditions.findIndex((x: any) => x.questID === item.questID && x.ConditionMet) === -1)
      || !this.Data.Conditions || this.Data.Conditions.findIndex((x: any) => x.questID === item.questID) === -1;
  }

  getFormattedText(): string[] {
    return this.selectedConditionQuestions.split('---');
  }

  isSkipped(item: any): boolean {
    return item?.rstValue === '<SKIP>' || item?.cmpID === '<SKIP>' || this.isSkippedList.includes(item?.questID);
  }

  getParent(item: any): any {
    const _self = this;
    return _self.questionnaireList.find(x => x.questKey === item.questParentkey);
  }

  getStatistics(): void {
    const _self = this;
    this.excRestServiceCore.sget(this.excRestServiceCore.computeUrl('QuestionnaireResultStatistics', {
      qverID: _self.Data.qverID,
      quest_qcnfID: _self.Data.qcnfID
    }), null, {})
      .subscribe((ret: any) => {
        if (ret.success && ret.data) {
          _self.Data.QuestionnaireStatistics = ret.data.Statiscts[0];
          this.fake = new Array(this.Data.QuestionnaireStatistics.QuestionsCount || 0);
          this.fakeCurrent = this.Data.QuestionnaireStatistics.ResultCount || 0;
        }
      });
  }

  getClass(questionnaire: any[], item: any, index: number): string {
    if (item !== undefined) {
      if (item.quest_enmIdent_questValueFormat === 1 || item.quest_enmIdent_questValueFormat === 2 ||
        item.quest_enmIdent_questValueFormat === 3) {
        if (item.quest_enmIdent_questType === 2) {
          return '';
        }
        if (questionnaire[index + 1] === undefined || item.questParentkey !== questionnaire[index + 1].questParentkey) {
          return 'bottom-part question-padding-bottom';
        } else {
          return 'vertical';
        }
      } else {
        return 'bottom-part ';
      }
    } else {
      return '';
    }
  }

  isEndable(): boolean {
    if (this.Data.QuestionnaireStatistics) {
      const statistic: any = this.Data.QuestionnaireStatistics;
      return [4, 5, 11].includes(statistic.TaskStatus) && statistic.ResultPercent === 100;
    } else {
      return false;
    }
  }

  isUndefined(value: any): any {
    if (value === undefined) {
      return null;
    }
  }

  getImageSrc(fs: string, mime: string): string {
    return 'data:' + mime + ';base64,' + fs;
  }

  getArray(str: string): string[] {
    let arr: string[] = JSON.parse(str);
    if (!arr) {
      arr = [];
    }
    return arr;
  }

  isChecked(rowIndex: number, colIndex: number, item: any): boolean {
    let isChecked = false;
    if (item.rstValue) {
      const config: any[] = JSON.parse(item.rstValue);
      if (config[rowIndex].cols[colIndex].score === item.configs[rowIndex].cols[colIndex].score) {
        isChecked = true;
      }
    }
    return isChecked;
  }

  isDeleteTable(item: any): boolean {
    let isDelete = true;
    const rstValue = JSON.parse(item.rstValue);
    rstValue.forEach((x: any) => {
      x.cols.forEach((y: any) => {
        if (y.score !== null) {
          isDelete = false;
        }
      });
    });
    return isDelete;
  }

  chapterHasPreText(chapter: any): boolean {
    return chapter && (chapter.questLink || chapter.questPreText || chapter.FileStream);
  }

  getChapterPercent(percentage: number, questionCount: number): string {
    if (questionCount > 0) {
      return percentage + '% ';
    } else {
      return '';
    }
  }
}
